import { render } from "./LookBigImage.vue?vue&type=template&id=39513f88&scoped=true"
import script from "./LookBigImage.vue?vue&type=script&steup=true&lang=js"
export * from "./LookBigImage.vue?vue&type=script&steup=true&lang=js"

import "./LookBigImage.vue?vue&type=style&index=0&id=39513f88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39513f88"]])

export default __exports__